
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M52.906 20.008H6.923a1 1 0 00-1 .995v18.1a1 1 0 001 .996h45.993a1 1 0 001-.996v-18.1a1.01 1.01 0 00-1.01-.995zm-9.209 10.911h-4.22V24.4h4.22v6.52zm.65-7.805h-5.52c-.36 0-.65.289-.65.647v7.168h-.969v-7.168a.647.647 0 00-.65-.647H31.04c-.36 0-.65.289-.65.647v7.168h-.97v-7.168a.647.647 0 00-.65-.647H23.25c-.36 0-.65.289-.65.647v7.168h-.97v-7.168a.647.647 0 00-.65-.647h-5.519c-.36 0-.65.289-.65.647v7.168h-1.2V22h32.566v8.93h-1.2v-7.168a.618.618 0 00-.63-.647zm-8.439 7.805h-4.22V24.4h4.22v6.52zm-7.779 0H23.91V24.4h4.22v6.52zm-7.788 0h-4.22V24.4h4.22v6.52zm31.565 7.189H7.913V21.998h3.709v9.926a1 1 0 001 .995h34.565a1 1 0 001-.995v-9.926h3.709v16.109h.01z"}})])
          )
        }
      }
    